import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getBlogReviewsById } from '../actions/reviewsActions';

interface ReviewsState {
  blogReviewsList: BlogReviewsListSuccessType;
  isLoading: boolean;
  error: string | null;
}

const initialState: ReviewsState = {
  blogReviewsList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  isLoading: false,
  error: null,
};

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    resetReviewsState: () => initialState,
    // You can add local updates here later, like adding a new review to the list immediately
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBlogReviewsById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        getBlogReviewsById.fulfilled,
        (state, action: PayloadAction<BlogReviewsListSuccessType>) => {
          state.isLoading = false;
          state.blogReviewsList = action.payload;
        }
      )
      .addCase(getBlogReviewsById.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload?.detail || 'Failed to fetch reviews';
      });
  },
});

export const { resetReviewsState } = reviewsSlice.actions;
export default reviewsSlice.reducer;